module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('h2', {
    staticClass: "p-3 border-bottom-light"
  }, [_vm._v("Rules")]), _vm._v(" "), (_vm.loadingPage) ? _c('div', {
    staticClass: "d-flex justify-content-center align-items-center vh-100"
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-center black mt-0"
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-center align-items-center vh-100"
  }, [_c('span', {
    staticClass: "dark bold loading"
  }, [_vm._v("Loading")]), _vm._v(" "), _c('loader')], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.hasDynamicPricingRevenuePlugin && !_vm.loadingPage) ? _c('div', {
    staticClass: "d-flex justify-content-center align-items-center vh-100"
  }, [_c('div', {
    staticClass: "d-flex flex-column justify-content-center subscription-msg panel bg-lightest black mt-0"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end flex-wrap"
  }, [_c('button', {
    staticClass: "btn btn-learn-more bold pointer ml-3 text-nowrap m-0",
    class: {
      'disabled notAllowed': !true
    },
    attrs: {
      "disabled": !true
    },
    on: {
      "click": function($event) {
        return _vm.openLearnMoreModal()
      }
    }
  }, [_c('span', [_vm._v("Learn more")])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    class: {
      'disabled notAllowed': !true
    },
    attrs: {
      "type": "button",
      "disabled": !true
    },
    on: {
      "click": function($event) {
        return _vm.execute()
      }
    }
  }, [_c('span', [_vm._v("Activate")])])])])]) : _vm._e(), _vm._v(" "), (_vm.hasDynamicPricingRevenuePlugin && !_vm.loadingPage) ? _c('div', {
    staticClass: "content",
    attrs: {
      "id": "rule-tabs"
    }
  }, [_c('tabs', [_c('tab', {
    attrs: {
      "name": "Rules Group"
    }
  }, [_c('tabRulesGroup')], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "name": "Rules"
    }
  }, [_c('tabRules')], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 font-weight-600"
  }, [_c('span', {
    staticClass: "fs-largest"
  }, [_vm._v("Pricing Rules")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-0 pb-5 pt-4 w-100"
  }, [_c('span', [_vm._v("The Pricing Rules functionality is currently "), _c('strong', [_vm._v("disabled")]), _vm._v(" on your account.")]), _vm._v(" "), _c('span', [_vm._v("To take advantage of its benefits and optimize your pricing and sales channel management,\n                    you’ll need to activate the add-on.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3b28b1fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b28b1fe"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/revenue/Rules.vue
// module id = 3096
// module chunks = 0